<template>
  <v-col cols="12" >
      <v-row >
        <v-col cols="12">
        <v-card  style="margin: 5px;" v-on:click="goToDetail(item)" v-for="item in request_items" :key="item.ReminderId">
            <div class="row ">
              <div class="col-12">
                <div
                  class="req-name"
                  v-text="item.ReminderText"
                ></div>
              </div>
              <div class="col-6">
                <div
                     class="req-name"
                     v-text="item.CreatorName"
                ></div>
              </div>
              <div class="text-center">
                <v-chip v-for="item_chip in JSON.parse(item.Receivers)"
                        class="ma-1"
                        color="primary"
                >
                  {{item_chip.PersonName}}
                </v-chip>
              </div>
              <div class="col-6">
                <div

                  class="req-name"
                  v-text="item.CreatedAt"
                ></div>
              </div>
              <div class="col-6">
                <div

                  class="req-name"
                  v-text="item.StatusTitle"
                ></div>
              </div>
            </div>
        </v-card>
        </v-col>
      </v-row>

    <v-dialog
      v-model="product_info_dialog"
      max-width="290"
      fullscreen
      hide-overlay
    >

      <v-card class="category-modal">
        <v-card-title class="headline">
          {{$t('changeStatusRequest')}}
        </v-card-title>
        <v-card-text>
          <v-row class="relative">
            <v-col cols="12">
              <v-select
                :items="request_statuses"
                :label="$t('NewStatusChangeStatus')"
                single-line
                item-text="ReminderStatusTitle"
                item-value="ReminderStatusId"
                v-model="selected_status_for_change"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="relative">
            <v-col cols="12">
              <v-textarea
                rows="2"
                v-model="change_status_summary" :placeholder="$t('insertChangeStatusSummary')"/>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>

          <v-btn
            class="cancle-btn"
            text
            @click="product_info_dialog = false"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-btn
            v-if="selected_status_for_change != 0"
            class="accept-btn"
            text
            @click="change_tech_status()"
          >
            {{$t('ok')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col>
        <v-btn v-on:click="go_to_finalize()" class="width-100-p" color="primary" v-if="enable_finalize">{{ $t('add_invoice') }}</v-btn>
      </v-col>
    </v-row>
  </v-col>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        selected_status_for_change:0,
        selected_reminder:0,
        change_status_summary:'',

        active_tab: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_statuses: [],
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 1,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {
      this.get_device_status();

    },

    methods: {
      get_device_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReminderStatus', send_data, {})
          .then(response => {
            self.request_statuses = response.data.items
            self.get_pre_requests();

          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_tech_status() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
          Summary:this.change_status_summary,
          ReminderId:this.selected_reminder,
          StatusId:this.selected_status_for_change,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ReminderStatus', send_data, {})
          .then(response => {
            self.request_statuses = response.data.items
            self.request_items=[];
            self.page=1;
            self.product_info_dialog = false;
            self.get_pre_requests();
            bus.$emit('show_toast', [2000, response.data.msg])

          }).catch(e => {
          this.errors.push(e)
        })
      },

      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'blue'
        } else {
          return 'white'
        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },
      get_pre_requests() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserReminderItems', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log("items great",response.data.result.length)

              if(response.data.result.length>0){
                response.data.result = response.data.result.filter(x => x.StatusTitle=="");
                response.data.result.forEach(function (val) {
                  self.request_items.push(val);
                })
              self.page++;
                self.get_pre_requests();

              }

            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler($state) {
        var self = this
        if (this.first) {
          // $state.loaded();
          setTimeout(() => {
            $state.loaded()
          }, 1000)
          return false
        }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
          self.page += 1
          self.get_pre_requests($state)
          // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
        }, 1000)
      },
      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item, is_parent) {
        if (this.disable_click) {
          return;
        }
          this.selected_product_info = item;
          this.product_info_dialog = true;
          this.selected_reminder = item.ReminderId
      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var array = this.request_items.filter(x => x.selected == true);

        var finalize_items = [];
        array.forEach(function (number) {
          if (number.related_products.length == 0) {
            finalize_items.push(number);
          } else {
            number.related_products.forEach(function (number2) {
              finalize_items.push(number2);
            })
          }

        });
        console.log("array is ",finalize_items)
        localStorage.setItem('buy_orders_finalize', JSON.stringify(finalize_items));
        this.$router.push({name: 'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
